import { SET_LANGUAGE } from './actionTypes';

export const setLanguage = (payload: string) => ({ type: SET_LANGUAGE, payload });